import axios from 'axios';

const api = axios.create({
  baseURL: 'https://api.etiquetas.equiperemota.com.br/',
});

export default api;
